import { Alert, AlertIcon, Box, Button, Flex, Image } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { PiWarningCircle } from 'react-icons/pi';

import { useAlert, useApi, useClipboard } from '@app/hooks';
import { Dialog, Txt } from '@app/components/common';
import { Equipment } from '@app/api/models';

export const PasteDialog = ({ open, outletId, onClose, onSelect }: {
  open: boolean,
  onClose: () => void,
  outletId?: string,
  onSelect: (items: Equipment[]) => void,
}) => {
  const [hasClipboard, setHasClipboard] = useState(false);
  const [openBufferInsertResultDialog, setOpenBufferInsertResultDialog] = useState(false);
  const [lostItems, setLostItems] = useState<string[]>([]);
  const api = useApi();
  const { success, warning } = useAlert();

  const { text } = useClipboard();

  useEffect(() => {
    if (text) {

      const separator = text.includes(',') ? ',' : '\n';
      const items = text.split(separator);
      if (items.length > 0) {
        setHasClipboard(true);
      }
    }
  }, [text]);

  const compareItems = (items: string[], equips: Equipment[]) => {
    const lostItems = items.filter((item) => !equips.find(({ serial_num }) => serial_num === item));
    setLostItems(lostItems);
    if (lostItems.length > 0) {
      setOpenBufferInsertResultDialog(true);
    }
  };

  const onPaste = async () => {
    if (!text) {return;}

    const separator = text.includes(',') ? ',' : '\n';
    const items = text.split(new RegExp('\\s*' + separator + '\\s*'));

    if (items.length > 0) {
      const getSerialNumbers = (items: string[]): string[] => {
        if (items[0] === 'ID;Модель;Серийный номер;Инвентарный номер') {
          return items.slice(1).map((item) => item.split(';')[2]).filter((item) => /^\d+$/.test(item));
        }
        return items.filter((item) => /^\d+$/.test(item));
      };

      const serial_num = getSerialNumbers(items);

      if (serial_num.length === 0) {
        warning('Неверный формат (нет серийных номеров)');
        return;
      }

      const equips = await api.equipments.getEquipmentsOutlet(outletId, { 
        filter: { 
          serial_num,
        },
        sort: '+id',
        offset: 0,
        limit: items.length,
      });


      if (equips.data.data.length === 0) {
        warning('Не найдено оборудованиe');
        return;
      }

      compareItems(serial_num, equips.data.data);

      success(`Список сформирован из ${equips.data.data.length} элементов`);

      onSelect(equips.data.data);
    }
    onClose();
  };

  return <>
    <Dialog 
      open={open}
      title='Вставить из буфера обмена'
      onClose={onClose} 
      actions={[
          <Button key="ok" isDisabled={!hasClipboard} colorScheme='brand' onClick={onPaste}>Вставить</Button>
        ]}
      width='auto'
    >
        <Alert status='info' >
          <AlertIcon />
          Скопируйте в буфер обмена перечень серийных номеров оборудования в одном из трех форматов
        </Alert>
        <Alert status='warning' >
          <AlertIcon />
          Отобранные ранее список ХО будут удалены. Список будет загружен снова.
        </Alert>
        <Flex justify='space-around' >
          <Box>
            <Txt>Из Excel:</Txt>
            <Image src='/images/excel-example.png' title='Из excel' w='243px' h='243px'  />
          </Box>
          <Box>
            <Txt>Текст в столбец:</Txt>
            <Image src='/images/text-example1.png' w='190px' h='220px' />
          </Box>
        </Flex>
        <Txt>Текст в строчку (разделитель <strong>запятая</strong>):</Txt>
        <Image src='/images/text-example2.png' />
      </Dialog>
      <Dialog 
        open={openBufferInsertResultDialog}
        title='Не найдено ХО'
        onClose={() => setOpenBufferInsertResultDialog(false)} 
        actions={[
          <Button key="ok" colorScheme='brand' onClick={() => setOpenBufferInsertResultDialog(false)}>Закрыть</Button>
        ]}
        width='auto'
      >
        <Alert status='error' >
          <AlertIcon />
          <p>Не найдены следующие серийные номера:</p>
        </Alert>
        <Box mt={2} maxW={500} wordBreak='break-word'>
          {lostItems.join(', ')}
        </Box>  
      </Dialog>
    </>;
};